<template>
    <c-inspection-data
        :has-data    = "hasData"
        :show-header = "false"
        :height      = "height"
        :status      = "status"
        :title       = "$t('disposition.conditions.menu')"
    >
        <template v-slot:body>
            <p-disposition-condition-escalator
                v-if       = "escalator"
                :escalator = "condition.escalator || undefined"
            />

            <div class="pr-1 pl-3 pt-1" v-else>
                <div class="v-flex w-100">
                    <div class="w-50 pr-2">
                        <c-name-value-header title = "Antrieb (Motor und Getriebe)" />
                        <c-rating-row     label="Bewertung"                                                                  :data="engine" />
                        <c-name-value-row label="Motor/Getriebeart" property="type"         type="siteTzbEngineType"         :data="engine" />
                        <c-name-value-row label="Hersteller"        property="manufacturer" type="manufacturer"              :data="engine" />
                        <c-name-value-row label="Typ"               property="model"                                         :data="engine" />
                    </div>

                    <div class="w-50 pl-2">
                        <c-name-value-header title = "Steuerung"  />
                        <c-rating-row     label="Bewertung"                                                                  :data="automatic" />
                        <c-name-value-row label="Steuerungsart"     property="type"         type="siteTzbAutomaticType"      :data="automatic" />
                        <c-name-value-row label="Sammelsteuerung"   property="type"         type="siteCollectiveControlType" :data="automatic" />
                        <c-name-value-row label="Hersteller"        property="manufacturer" type="manufacturer"              :data="automatic" />
                        <c-name-value-row label="Typ"               property="model"                                         :data="automatic" />
                    </div>
                </div>

                <div class="v-flex w-100 mt-8">
                    <div class="w-50 pr-2">
                        <c-name-value-header title = "Regelung" />
                        <c-rating-row     label="Bewertung"                                                                  :data="control" />
                        <c-name-value-row label="Regelungsart"      property="type"         type="siteTzbControlType"        :data="control" />
                        <c-name-value-row label="Hersteller"        property="manufacturer" type="manufacturer"              :data="control" />
                        <c-name-value-row label="Typ"               property="model"                                         :data="control" />
                    </div>

                    <div class="w-50 pl-2">
                        <c-name-value-header title = "Geschwindigkeitsbegrenzer"  />
                        <c-rating-row     label="Bewertung"                                                                  :data="speedLimiter" />
                        <c-name-value-row label="GB-Art"            property="type"         type="siteTzbSpeedlimiterType"   :data="speedLimiter" />
                        <c-name-value-row label="Hersteller"        property="manufacturer" type="manufacturer"              :data="speedLimiter" />
                        <c-name-value-row label="Typ"               property="model"                                         :data="speedLimiter" />
                    </div>
                </div>

                <div class="v-flex w-100 mt-8">
                    <div class="w-50 pr-2">
                        <c-name-value-header title = "Kopierung"  />
                        <c-name-value-row label="Art"               property="type"         type="siteTzbKopierungType"   :data="speedLimiter" />
                    </div>

                    <div class="w-50 pl-2">
                        <c-name-value-header title = "Fangvorrichtung"  />
                        <c-name-value-row label="Fangvorrichtungsart" property="type"         type="siteTzbSaftyCatchType"   :data="safetyCatch" />
                        <c-name-value-row label="Hersteller"        property="manufacturer" type="manufacturer"              :data="safetyCatch" />
                        <c-name-value-row label="Typ"               property="model"                                         :data="safetyCatch" />
                    </div>
                </div>

                <div class="v-flex w-100 mt-8">
                    <div class="w-50 pr-2">
                        <c-name-value-header title = "Schachttüren"  />
                        <c-rating-row     label="Bewertung"                                                                  :data="liftShaftDoor" />
                        <c-name-value-row label="Schachttürart"     property="type"         type="siteTzbLiftShaftDoorType"   :data="liftShaftDoor" />
                        <c-name-value-row label="Hersteller"        property="manufacturer" type="manufacturer"              :data="liftShaftDoor" />
                        <c-name-value-row label="Typ"               property="model"                                         :data="liftShaftDoor" />
                    </div>

                    <div class="w-50 pl-2">
                        <c-name-value-header title = "Fahrkorbtür"  />
                        <c-rating-row     label="Bewertung"                                                                  :data="cardoor" />
                        <c-name-value-row label="Türart"            property="type"         type="siteTzbCarDoorType"        :data="cardoor" />
                        <c-name-value-row label="Türantriebsart"    property="doorDriveTyp" type="siteTzbDoorDriveType"      :data="cardoor" />
                        <c-name-value-row label="Hersteller"        property="manufacturer" type="manufacturer"              :data="cardoor" />
                        <c-name-value-row label="Typ"               property="model"                                         :data="cardoor" />
                    </div>
                </div>

                <div class="v-flex w-100 mt-8">
                    <div class="w-50 pr-2">
                        <c-name-value-header title = "Fahrkorb"  />
                        <c-rating-row     label="Bewertung"                                                                  :data="car" />
                        <c-rating-row     label="Vandalismus"       property="vandalism"                                     :data="car" />
                        <c-name-value-row label="Wandmaterial"      property="wall"         type="siteTzbCarWallType"        :data="car" />
                        <c-name-value-row label="Boden"             property="floor"        type="siteTzbCarFloorType"       :data="car" />
                        <c-name-value-row label="Deckenmaterial"    property="ceiling"      type="siteTzbCarCeilingType"     :data="car" />
                        <c-name-value-row label="Beleuchtung"       property="lighting"     type="siteTzbCarLightingType"    :data="car" />
                        <c-name-value-row label="Spiegel"           property="mirror"       type="siteTzbCarMirrorType"      :data="car" />
                    </div>

                    <div class="w-50 pl-2">
                        <c-name-value-header title = "Notrufleitsystem"  />
                        <c-name-value-row label="NRL-Art"           property="type"         type="siteTzbEmcSystemType"      :data="emcSystem" />
                        <c-name-value-row label="Hersteller"        property="manufacturer" type="manufacturer"              :data="emcSystem" />
                        <c-name-value-row label="Typ"               property="model"                                         :data="emcSystem" />
                    </div>
                </div>

                <div class="v-flex w-100 mt-8">
                    <div class="w-50 pr-2">
                        <c-name-value-header title = "Anlagenzustand" />
                        <c-rating-row     label="Bewertung"                                                                  :data="unit" />
                        <div class="notice lm-border pa-2" style="margin-top: 62px">
                            {{ unit.notice }}
                        </div>
                    </div>

                    <div class="w-50 pl-2">
                        <c-name-value-header title = "Wartungsqualität"  />
                        <c-rating-row     label="Triebwerksraum"     property="engineRoomRating"                                                                :data="maintenance" />
                        <c-rating-row     label="Schacht und Grube" property="manWholeRating"                                                               :data="maintenance" />
                        <c-rating-row     label="Fahrkorbdach"        property="carRoofRating"                                                        :data="maintenance" />

                        <div class="notice lm-border pa-2 mt-1">
                            {{ maintenance.notice }}
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </c-inspection-data>
</template>

<script>

import PAreaMixin       from "@/modules/dis/components/inspection/common/mixins/PAreaMixin";
import CInspectionData  from "@/modules/dis/components/inspection/common/components/CInspectionData.vue";
import CNameValueHeader from "@/modules/dis/components/inspection/common/components/CNameValueHeader.vue";
import CNameValueRow    from "@/modules/dis/components/inspection/common/components/CNameValueRow.vue";
import CRatingRow       from "@/modules/dis/components/inspection/common/components/CRatingRow.vue";
import ConditionLayout  from "@/modules/dis/service/inspection/ConditionLayout";
import PDispositionConditionEscalator
    from "@/modules/dis/components/inspection/condition/components/PDispositionConditionEscalator.vue";

export default {
    name: "PDispositionCondition",
    components: {
        PDispositionConditionEscalator,
        CRatingRow,
        CNameValueRow,
        CNameValueHeader,
        CInspectionData,
    },

    mixins: [
        PAreaMixin
    ],

    computed: {
        condition () {
            if (!this.inspection || !this.inspection.condition) {
                return;
            }

            return this.inspection.condition;
        },

        unit () {
            return this.condition.unit;
        },

        maintenance () {
            return this.condition.maintenance;
        },

        status () {
            return this.condition ? this.condition.status : null;
        },

        engine () {
            return this.condition.engine;
        },

        control () {
            return this.condition.control;
        },

        automatic () {
            return this.condition.automatic;
        },

        speedLimiter () {
            return this.condition.speedLimiter;
        },

        safetyCatch () {
            return this.condition.safetyCatch;
        },

        liftShaftDoor () {
            return this.condition.liftShaftDoor;
        },

        cardoor () {
            return this.condition.doorDrive;
        },

        car () {
            return this.condition.car;
        },

        emcSystem () {
            return this.condition.emcSystem;
        },

        hasData () {
            return !!this.condition;
        },

        /** Escalator TZB instead of the elevator TZB (HCIT-1143): the device type of the app decides. */
        escalator () {
            return ConditionLayout.isEscalator(this.inspection);
        }
    },
}
</script>

<style scoped>

.notice {
    width: 100%;
    height: 90px;
}

</style>